<template>
	<footer
		v-if="footer"
		aria-labelledby="footer-heading"
		class="m-auto bg-quaternary"
	>
		<div class="main-wrapper lg:!p-10 !p-5">
			<NuxtLink
				v-if="footer?.logo"
				:to="localePath(`/`)"
				class="mb-10 w-4/5 lg:w-full h-auto max-w-[80%] lg:max-w-[300px] block"
			>
				<NuxtImg
					:src="footer.logo.filename"
					:alt="footer.logo?.alt || 'logo'"
					class="block w-full h-auto relative -left-2.5"
					:width="300"
					:height="150"
					loading="eager"
				/>
			</NuxtLink>
			<div class="flex w-full gap-10 lg:flex-nowrap flex-wrap justify-between">
				<div
					class="flex w-full justify-between sm:flex-nowrap flex-wrap gap-4 lg:gap-0 lg:max-w-[30%]"
				>
					<StoryblokComponent
						v-for="block in footer.items"
						:key="block._uid"
						:blok="block"
						class="flex flex-col gap-4 lg:gap-6 lg:w-full w-full lg:max-w-[calc(33%-32px)] sm:max-w-[calc(50%-32px)]"
					/>
				</div>
				<Newsletter
					v-if="footer.newsletter?.[0]"
					:blok="footer.newsletter[0]"
					class="-order-1 lg:order-none lg:max-w-[46%] w-full"
				/>
			</div>
		</div>
		<div class="w-full pb-6 text-center">
			<WithdrawalFooterLink />
		</div>
	</footer>
</template>

<script setup lang="ts">
const { footer } = useAppStore();
const localePath = useLocalePath();
</script>
